import * as moment from "moment"
import { v4 as uuid } from "uuid"

export let interval = null

/**
 * @param pattern - Formato de tipo fecha, hora, segundos ej. YYYY-DD-MM
 * @returns Fecha tipo String con el formato pasado desde el parametro.
 */
export const getSpecificDateType = (pattern?: string) => {
    if (pattern) return moment().format(pattern)
    else return moment().format()
}

/**
 * Toma el nombre del medico pasado por los params de la URL y lo transforma en una cadena de texto
 *
 * @param {string} name Nombre del medico de los params
 * @return {string}  Cadena de texto con el nombre formateado
 */
export const formatMedicName = (name: string): string => {
    const finalName = name.split("$")

    let formatedName: string = ''

    if (finalName.length === 1) return finalName[0]

    finalName.forEach((name, i) => {
        if (i >= finalName.length - 1) {
            formatedName += name
        } else {
            formatedName += name + ' '
        }
    })

    return formatedName
}

export const createInterval = (time: number, callback: Function) => {
    if (interval !== null) {
        clearInterval(interval)
        interval = null
    }

    interval = setInterval(callback, time)
}

/**
 * Elimina el tiempo transcurrido de la VC del LocalStorage y elimina el intervalo
 * @returns void
 */
export const clearTimer = (): void => {
    clearInterval(interval)
    interval = null
    localStorage.removeItem('time')
}

/**
 * Genera un UUID y lo guarda el localStorage como "uuid"
 * @returns void
*/
export const generateUUID = (): string => {
    let UUID = ''

    if (localStorage.getItem('uuid')) UUID = localStorage.getItem('uuid')
    else {
        UUID = uuid()
        localStorage.setItem('uuid', UUID)
    }

    return UUID
}

export const getUUID = (): string => {
  return localStorage.getItem('uuid') || ''
}

/**
 * Elimina el uuid del LocalStorage
 * @returns void
 */
export const removeUUIDFromLocalStorage = (): void => {
    localStorage.removeItem('uuid')
}

/**
 * Limpia el LocalStorage de todos los datos menos el token
 * @returns void
 */
export const clearLocalStorage = (): void => {
    const token = localStorage.getItem('token')
    localStorage.clear()
    localStorage.setItem('token', token == null ? '' : token)
}